<div class="page-title animatedBackground">
    <div class="container">
        <h3>HR Management System</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li><a routerLink="/our-solutions">Our Solutions</a></li>
            <li class="dot-divider"></li>
            <li>HR Management System</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-overview">
            <div class="services-details-desc">
                <h3>Saudi Localized Custom HR Management System</h3>
                <p>OSIT Custom Designed human resource management solution provides a suite of capabilities that make HR service delivery easier and more efficient for everyone, across the organization. With a single tool to manage human resources, payroll and financials, organizations can eliminate third-party integrations, improve data accuracy, create a more engaging workforce experience and make better-informed decisions to tightly align workforce performance with business performance.</p>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Bring your HR and financial data in one place.</h4>
                    <h4><i class="icofont-check-alt"></i> Reduce HR Administrative effort and cost.</h4>
                    <h4><i class="icofont-check-alt"></i> Connect deeply with your employee.</h4>
                    <h4><i class="icofont-check-alt"></i> Improve HR Service Delivery.</h4>
                    <h4><i class="icofont-check-alt"></i> Increase workforce performance.</h4>
                </div>
              
            </div>

            <div class="services-details-image">
                <img src="assets/img/hr-new.png" alt="image">
            </div>
        </div>

        <div class="services-details-overview">
            <div class="services-details-image">
                <img src="assets/img/hr-management-system.jpg" alt="image">
            </div>

            <div class="services-details-desc">
                <h3>Features</h3>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i>Employee Management</h4>
                    <h4><i class="icofont-check-alt"></i>Self Service</h4>
                    <h4><i class="icofont-check-alt"></i>Attendance</h4>
                    <h4><i class="icofont-check-alt"></i>Payroll</h4>
                    <h4><i class="icofont-check-alt"></i>Leaves</h4>
                    <h4><i class="icofont-check-alt"></i>Loan</h4>
                    <h4><i class="icofont-check-alt"></i>Contract</h4>
                    <h4><i class="icofont-check-alt"></i>Recruitment </h4>
                    <h4><i class="icofont-check-alt"></i>Employee Performance</h4>
                    <h4><i class="icofont-check-alt"></i>Request Management</h4>
                    <h4><i class="icofont-check-alt"></i>Letter management</h4>
                    
                </div>
                
            </div>
        </div>
    </div>
</section>

